import Grid2 from "@mui/material/Grid2";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import { useSearchParamsToReducer } from "../hooks/useSearchParamsToReducer";
import { SearchFilter } from "./SearchFilter";
import { useTemplatesContext } from "../../context/templatesContext";

export const Filters = () => {
	useSearchParamsToReducer();
	const {
		state: { showDownDay },
		actions: { setShowDownDay },
	} = useTemplatesContext();

	return (
		<Grid2 container spacing={1} alignItems="center">
			<Grid2 size={{ md: 8, xs: 12 }}>
				<SearchFilter />
			</Grid2>
			<Grid2 size={{ md: 4, xs: 12 }}>
				<Tooltip title="Show templates flagged as down day">
					<FormControlLabel
						control={
							<Checkbox
								checked={!!showDownDay}
								onChange={(e) => setShowDownDay(e.target.checked)}
								color="primary"
							/>
						}
						label="Down day"
					/>
				</Tooltip>
			</Grid2>
		</Grid2>
	);
};
